import { createContext, useContext, useEffect, useState } from "react";

const ACCENTS = {
  solar: { name: "Solar Flare Orange", hex: "#FF5722", hover: "#F97316" },
  lime: { name: "Electric Hyper Lime", hex: "#84CC16", hover: "#A3E635" },
  amber: { name: "Coral Wave Amber", hex: "#F59E0B", hover: "#FFB703" },
};

const AccentCtx = createContext(null);
export const useAccent = () => useContext(AccentCtx);
export { ACCENTS };

export function AccentProvider({ children }) {
  const [key, setKey] = useState(() => localStorage.getItem("sg_accent") || "solar");

  useEffect(() => {
    const a = ACCENTS[key] || ACCENTS.solar;
    document.documentElement.style.setProperty("--accent", a.hex);
    document.documentElement.style.setProperty("--accent-hover", a.hover);
    localStorage.setItem("sg_accent", key);
  }, [key]);

  return <AccentCtx.Provider value={{ key, setKey, accents: ACCENTS }}>{children}</AccentCtx.Provider>;
}
